import React, { Component } from 'react';
import { bool, func, string } from 'prop-types';
import LoadingList from '../LoadingStates/LoadingList';
import './ReloadableSection.scss';

class ReloadableSection extends Component {
  static propTypes = {
    errorMessage: string,
    reloadAction: func,
    showReload: bool
  };

  render() {
    const { errorMessage, reloadAction, showReload } = this.props;

    return (
      <div className="home-page__reload-container">
        <i className="icon-warning" />
        <div>{errorMessage}</div>
        {showReload && (
          <a onClick={reloadAction}>
            <i className="icon-spin" /> Reload this section
          </a>
        )}
      </div>
    );
  }
}

export default ReloadableSection;
